import { useCallback } from "react";
import { isEqual } from "@util/utils";
import { stringifyQuery } from "@util/query.util";

const findPrevNext = (list, targetID, targetName) => {
	if (targetName === "") return {};
	const index = list.findIndex(item => isEqual(item[targetName], targetID));

	if (index === -1) {
		return { prev: null, current: null, next: null };
	}

	return {
		prev: list[index - 1]?.[targetName] ?? null,
		current: list[index][targetName],
		next: list[index + 1]?.[targetName] ?? null,
	};
};

const tryFindRow = (id, keyName, tableRef) => {
	if (!id) return null;

	const el = tableRef.current.querySelector(`[${keyName}="${id}"]`);
	return el?.closest("tr") ?? null;
};

const useTableScrollerTo = ({ tableRef, cacheKeyName = "nonmember-scroller", domKeyName = "data-customer-id", uniqueIdName = "" }) => {
	const setCache = (list, id, query) => {
		const target = findPrevNext(list, id, uniqueIdName);
		if (query) target.query = stringifyQuery(query);
		localStorage.setItem(cacheKeyName, JSON.stringify(target));
	};

	const doScrollerTo = useCallback(
		() => {
			setTimeout(() => {
				const raw = localStorage.getItem(cacheKeyName);
				if (!raw || !tableRef.current) return;

				let payload;
				try {
					payload = JSON.parse(raw);
				} catch {
					return;
				}

				const tr = tryFindRow(payload?.current, domKeyName, tableRef) || tryFindRow(payload?.next, domKeyName, tableRef) || tryFindRow(payload?.prev, domKeyName, tableRef);
				if (!tr) return;

				tr.scrollIntoView({ behavior: "smooth", block: "center" });
				tr.classList.add("flash-highlight");

				localStorage.removeItem(cacheKeyName);

				setTimeout(() => {
					tr.classList.remove("flash-highlight");
				}, 5000);
			}, 300);
		},
		// eslint-disable-next-line
		[]
	);

	return { setCache, doScrollerTo, domKeyName };
};

export default useTableScrollerTo;
